import React from 'react';
import { Link } from 'react-router-dom';

export default function CartTotals({value}) {
  const { cartSubTotal, cartTax, cartTotal, clearCart } = value;
  return (
    <React.Fragment>
      <div className="cartTotalsContainer">
        <div className="cartTotalsRow">
          <div className="cartTotalsCol">
            <Link to="/">
              <button id="clearCartBtn" onClick={()=>clearCart()}>Clear Cart</button>
            </Link>
            <h5>
              <span>SubTotal: </span>
              <strong>${cartSubTotal}</strong>
            </h5>
            <h5>
              <span>Tax: </span>
              <strong>${cartTax}</strong>
            </h5>
            <h5>
              <span>Total: </span>
              <strong>${cartTotal}</strong>
            </h5>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
